import React, { Component } from 'react';
import withLocale from '../../locale/withLocale';

class Footer extends Component {
  contactClick = () => {
    if (this.props.onContactClick) {
      this.props.onContactClick();
    }
  };

  render() {
    const { t } = this.props;
    return (
      <footer className="main-footer" id="main-footer">
        <div className="support">
          <div className="inner">
            <a className="icon-info2" href={t('footer_aboutCreditinfo_link')} target="_blank">
              {t('footer_aboutCreditinfo')}
            </a>
            <a
              href={this.props.onContactClick ? null : 'mailto:creditinfo@creditinfo.is'}
              className="icon-envelope"
              onClick={this.contactClick}
            >
              {t('footer_contactUs')}
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default withLocale(Footer);



// WEBPACK FOOTER //
// ./src/common/jsx/layout/Footer/index.js